import React, { Component } from "react";
import "./Swiper.less";

class Swiper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
    };
  }

  prevSlide = () => {
    this.setState((prevState) => ({
      currentIndex: Math.max(prevState.currentIndex - 1, 0),
    }));
  };

  nextSlide = () => {
    const maxIndex = React.Children.count(this.props.children) - this.props.slidesPerView;
    this.setState((prevState) => ({
      currentIndex: Math.min(prevState.currentIndex + 1, maxIndex),
    }));
  };

  render() {
    const { children, slidesPerView } = this.props;
    const { currentIndex } = this.state;

    return (
      <div className="swiper" style={{'--slides-per-view' : slidesPerView}}>
        <span
          className={`swiper-button prev ${currentIndex === 0 && 'disabled'}`}
          onClick={this.prevSlide}
        >
          <i className="fa fa-chevron-left"></i>
        </span>

        <div className="swiper-wrapper">
          <div
            className="swiper-track"
            style={{ transform: `translateX(-${currentIndex * (100 / slidesPerView)}%)` }}
          >
            {React.Children.map(children, (child, index) => (
              <div key={index} className="swiper-slide">
                {child}
              </div>
            ))}
          </div>
        </div>

        <span
          className={`swiper-button next ${currentIndex >= React.Children.count(children) - slidesPerView && 'disabled'}`}
          onClick={this.nextSlide}
        >
          <i className="fa fa-chevron-right"></i>
        </span>
      </div>
    );
  }
}

export default Swiper;
